import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'devextreme/data/odata/store';
import { useAuth } from '../../contexts/auth';
import DataGrid, {
  Column,
  Editing,
  Popup,
  Paging,
  Form,
  SearchPanel,
  FilterRow,
  HeaderFilter,
  GroupPanel,
  Export,
  ColumnChooser,
  Pager,
  Scrolling,
  Summary,
  TotalItem,
  LoadPanel,
  Toolbar,
} from 'devextreme-react/data-grid';
import { Item, } from 'devextreme-react/form';
import './drivers.scss';
import axios from 'axios';
import { Button, TagBox } from 'devextreme-react';
import dxDataGrid from 'devextreme/ui/data_grid';
import dxForm from 'devextreme/ui/form';

export default function Drivers() {
  
  const baseUrl = process.env.REACT_APP_API_URL;
  const [driverDays, setDriverDays] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeSlots, setActiveSlots] = useState<any[]>([]);
  const [currentEditDriver, setCurrentEditDriver] = useState<any>({});
  const [mondayValues, setMondayValues] = useState<string[]>([]);
  const [tuesdayValues, setTuesdayValues] = useState<string[]>([]);
  const [wednesdayValues, setWednesdayValues] = useState<string[]>([]);
  const [thursdayValues, setThursdayValues] = useState<string[]>([]);
  const [fridayValues, setFridayValues] = useState<string[]>([]);
  const [saturdayValues, setSaturdayValues] = useState<string[]>([]);
  const [sundayValues, setSundayValues] = useState<string[]>([]);

  const { user } = useAuth();

  const driverDataGridRef = useRef<dxDataGrid>(null);
  const driverFormRef = useRef<dxForm>(null);

  useEffect(() => {
    getDriverDays();
    getActiveSlots();
  }, [user]);

  const getDriverDays = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/Driver/driverDays`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setDriverDays(response.data.data))
      .then(() => {
        setTimeout(() => {
          if (driverDataGridRef?.current) {
            driverDataGridRef.current.refresh();
          }
        }, 0);
      })
      .catch(error => console.error('Error fetching bookings:', error))
      .finally(() => setLoading(false));
  };

  const getActiveSlots = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/slots`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })	
      .then(response => setActiveSlots(response.data.data))
      .catch(error => console.error('Error fetching slots:', error))
      .finally(() => setLoading(false));
  };

  const onDriverSaving = async (e: any) => {
    const prevMondayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Monday")?.slots?.map((slot: any) => slot?.time);
    const prevTuesdayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Tuesday")?.slots?.map((slot: any) => slot?.time);
    const prevWednesdayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Wednesday")?.slots?.map((slot: any) => slot?.time);
    const prevThursdayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Thursday")?.slots?.map((slot: any) => slot?.time);
    const prevFridayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Friday")?.slots?.map((slot: any) => slot?.time);
    const prevSaturdayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Saturday")?.slots?.map((slot: any) => slot?.time);
    const prevSundayValues = currentEditDriver?.daySlots?.find((daySlot: any) => daySlot?.day === "Sunday")?.slots?.map((slot: any) => slot?.time);

    let slotsToUpdate: any[] = [];

    if (prevMondayValues?.sort().toString() !== mondayValues?.sort().toString()) {
      const mondaySlots = activeSlots.filter(slot => mondayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 1, driverId: currentEditDriver.driver.id, slotIds: mondaySlots });
    }
      
    if (prevTuesdayValues?.sort().toString() !== tuesdayValues?.sort().toString()) {
      const tuesdaySlots = activeSlots.filter(slot => tuesdayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 2, driverId: currentEditDriver.driver.id, slotIds: tuesdaySlots });
    }
      
    if (prevWednesdayValues?.sort().toString() !== wednesdayValues?.sort().toString()) {
      const wednesdaySlots = activeSlots.filter(slot => wednesdayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 3, driverId: currentEditDriver.driver.id, slotIds: wednesdaySlots });      
    }
      
    if (prevThursdayValues?.sort().toString() !== thursdayValues?.sort().toString()) {
      const thursdaySlots = activeSlots.filter(slot => thursdayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 4, driverId: currentEditDriver.driver.id, slotIds: thursdaySlots });
    }
      
    if (prevFridayValues?.sort().toString() !== fridayValues?.sort().toString()) {
      const fridaySlots = activeSlots.filter(slot => fridayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 5, driverId: currentEditDriver.driver.id, slotIds: fridaySlots });
    }
      
    if (prevSaturdayValues?.sort().toString() !== saturdayValues?.sort().toString()) {
      const saturdaySlots = activeSlots.filter(slot => saturdayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 6, driverId: currentEditDriver.driver.id, slotIds: saturdaySlots });
    }
      
    if (prevSundayValues?.sort().toString() !== sundayValues?.sort().toString()) {
      const sundaySlots = activeSlots.filter(slot => sundayValues.includes(slot.time)).map(slot => slot.id);
      slotsToUpdate.push({ dayId: 7, driverId: currentEditDriver.driver.id, slotIds: sundaySlots });
    }

    if(slotsToUpdate.length > 0) updateDriverSlotDays(slotsToUpdate);
  };


  const updateDriverSlotDays = async (driverSlotDays: any) => {
    try {
      await axios.put(`${baseUrl}/api/Driver/updateDriverSlotDays`, driverSlotDays, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then(response => {
          getDriverDays();
          setTimeout(() => driverDataGridRef.current?.repaint(), 3000);          
          return response.data.data;
        });
    }
    catch(e) {
      console.error(e)
    }
  }

  const handleEdit = useCallback((data: any) => {
    driverDataGridRef.current?.editRow(driverDataGridRef.current?.getRowIndexByKey(data.id))
    setCurrentEditDriver(data);
    const mondayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Monday");
    setMondayValues(mondayObject?.slots?.map((slot: any) => slot.time));
    const tuedayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Tuesday");
    setTuesdayValues(tuedayObject?.slots?.map((slot: any) => slot.time));
    const wednesdayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Wednesday");
    setWednesdayValues(wednesdayObject?.slots?.map((slot: any) => slot.time));
    const thursdayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Thursday");
    setThursdayValues(thursdayObject?.slots?.map((slot: any) => slot.time));
    const fridayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Friday");
    setFridayValues(fridayObject?.slots?.map((slot: any) => slot.time));
    const saturdayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Saturday");
    setSaturdayValues(saturdayObject?.slots?.map((slot: any) => slot.time));
    const sundayObject = data?.daySlots?.find((daySlot: any) => daySlot?.day === "Sunday");
    setSundayValues(sundayObject?.slots?.map((slot: any) => slot.time));
  }, []);

  const renderGridCell = (cellData: any) => {
    return (
      <div className="dx-command-cell" style={{ display: 'flex', justifyContent: 'space-around' }}>
        <Button className={'edit'} icon="edit" onClick={() => handleEdit(cellData.data)} style={{ color: 'rgba(178, 235, 242, 0.7)' }} />
      </div>
    );
  };

  const onEditorPreparing = useCallback((e: any) => {
    if (e?.row?.data?.daySlots) {
    }
  }, []);

  const onInitialized = useCallback((e: any) => {
    driverDataGridRef.current = e.component;
  }, []);

  const onFormInitialized = useCallback((e: any) => {
    driverFormRef.current = e.component;  
  }, []);  

  const onCellPrepared = (e: any) => {  
    if (e.column.command === "edit") {  
      e.cellElement.style.display = 'none';
    }
  } 

  const onMondayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setMondayValues(e.value);
  }, []);
  const onTuesdayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setTuesdayValues(e.value);
  }, []);
  const onWednesdayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setWednesdayValues(e.value);
  }, []);
  const onThursdayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setThursdayValues(e.value);
  }, []);
  const onFridayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setFridayValues(e.value);
  }, []);
  const onSaturdayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setSaturdayValues(e.value);
  }, []);
  const onSundayTagBoxValueChanged = useCallback((e: any) => {
    if( JSON.stringify(e.previousValue) !== JSON.stringify(e.value)) setSundayValues(e.value);
  }, []);

  return (
    <React.Fragment>      
      <h2>Fahrer</h2>
      <DataGrid
        className={'dx-card content-block dx-datagrid-compact'}
        dataSource={driverDays}
        keyExpr="id"
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        showBorders={true}
        columnAutoWidth={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        columnHidingEnabled={true}
        repaintChangesOnly={true}
        onSaving={onDriverSaving}
        onCellPrepared={onCellPrepared}
        onInitialized={onInitialized}
        onEditorPreparing={onEditorPreparing}
        >
        <LoadPanel enabled={true} showIndicator={loading}/>
        <SearchPanel visible={true} width={240} placeholder="Search..." />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <GroupPanel visible={false} />
        <Export enabled={false} />
        <ColumnChooser enabled={false} mode='select' height={'600'}/>
        <Toolbar>
          <Item name="searchPanel" />
          <Item name="columnChooserButton" />
        </Toolbar>
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[5, 10]}
          showInfo={true}
        />
        <Summary>
            <TotalItem column="driver.driverId" summaryType="count" />
        </Summary>
        <Editing
          refreshMode={'repaint'}
          mode="popup"
          useIcons={true}
          allowUpdating={true}
          allowDeleting={true}
          allowAdding={true}
          texts={{ confirmDeleteMessage: 'Möchten Sie diese Fahrer wirklich stornieren?' }}>
          <Popup title="Fahrer" showTitle={true} width={'98%'} height={'85%'}/>    
          <Form onInitialized={onFormInitialized}>
            <Item itemType="group" colCount={3} colSpan={2}>

              {/* Basic Information */}
              <Item itemType="group" caption="Basisinformationen" colCount={7} colSpan={3}>
                <Item dataField="id" colSpan={1}/>
                <Item dataField="driver.driverId" colSpan={1}/>  
                <Item dataField="driver.user.email" colSpan={1}/> 
                <Item dataField="driver.user.firstName" colSpan={1}/> 
                <Item dataField="driver.user.lastName" colSpan={1}/>
                <Item dataField="driver.user.phoneNumber" colSpan={1}/>
                <Item dataField="driver.user.isActive" colSpan={1}/>                          
              </Item>
              {/* Slot managment */}
              <Item itemType="group" caption="Verfügbarkeit" colCount={7} colSpan={3}> 
                <Item dataField='Montag' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={mondayValues}
                    onValueChanged={onMondayTagBoxValueChanged}
                  />
                </Item>  
                <Item dataField='Dienstag' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={tuesdayValues}
                    onValueChanged={onTuesdayTagBoxValueChanged}
                  />
                </Item>  
                <Item dataField='Mittwoch' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={wednesdayValues}
                    onValueChanged={onWednesdayTagBoxValueChanged}
                  />
                </Item>  
                <Item dataField='Donnerstag' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={thursdayValues}
                    onValueChanged={onThursdayTagBoxValueChanged}
                  />
                </Item>  
                <Item dataField='Freitag' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={fridayValues}
                    onValueChanged={onFridayTagBoxValueChanged}
                  />
                </Item>  
                <Item dataField='Samstag' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={saturdayValues}
                    onValueChanged={onSaturdayTagBoxValueChanged}
                  />
                </Item>  
                <Item dataField='Sonntag' colSpan={1}> 
                  <TagBox
                    items={activeSlots}
                    showSelectionControls={true}
                    placeholder="Slots"	
                    displayExpr="time"
                    valueExpr="time"
                    applyValueMode="useButtons"
                    maxFilterQueryLength={2000}
                    value={sundayValues}
                    onValueChanged={onSundayTagBoxValueChanged}
                  />
                </Item>                            
              </Item>
            </Item>
          </Form>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        {/* <Scrolling mode="standard" /> */}
        <Scrolling useNative={true} showScrollbar="always" />
        <Column dataField="id" sortIndex={0} sortOrder="asc" width={50} allowEditing={false}/>
        <Column dataField="driver.driverId" caption="Fahrer-ID" width={120} fixed={true} fixedPosition="sticky" allowEditing={false}/>
        <Column dataField="driver.user.email" caption="Email" width={200} allowEditing={false}/>
        <Column dataField="driver.user.firstName" caption="VorName" width={120} allowEditing={false}/>
        <Column dataField="driver.user.lastName" caption="NachName" width={120} allowEditing={false}/>
        <Column dataField="driver.user.phoneNumber" caption="Handy" width={140} allowEditing={false}/>
        <Column dataField="driver.user.isActive" caption="Active" width={120} allowEditing={false}/>
        <Column dataField="Montag" caption="Montag" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Monday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>
        <Column dataField="Dienstag" caption="Dienstag" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Tuesday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>
        <Column dataField="Mittwoch" caption="Mittwoch" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Wednesday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>
        <Column dataField="Donnerstag" caption="Donnerstag" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Thursday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>
        <Column dataField="Freitag" caption="Freitag" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Friday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>
        <Column dataField="Samstag" caption="Samstag" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Saturday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>
        <Column dataField="Sonntag" caption="Sonntag" cellRender={(cellData) => {
          const dayObject = cellData?.data?.daySlots?.find((daySlot: any) => daySlot?.day === "Sunday");
          const timeSlotString = dayObject?.slots?.map((slot: any) => slot.time).join(' | ');
          return timeSlotString ? '| '+timeSlotString+' |' : '-';
          }}/>

        {/* Command column */}
        <Column fixed={true} fixedPosition="sticky"  width={135}
            caption="Aktionen"
            alignment="center"
            cellRender={renderGridCell}
            cssClass="no-padding-column" />
      </DataGrid>
    </React.Fragment>
)}